/*eslint @typescript-eslint/no-unused-vars: "off"*/
/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @interface FormQuestionUpdateStatus
 */
export interface FormQuestionUpdateStatus {
    /**
     * 
     * @type {string}
     * @memberof FormQuestionUpdateStatus
     */
    status: FormQuestionUpdateStatusStatusEnum;
}




/**
* @export
* @enum {string}
*/
export enum FormQuestionUpdateStatusStatusEnum {
    DONE = 'DONE',
    FLAGGED = 'FLAGGED',
    PENDING = 'PENDING'
}


